import { BehaviorSubject, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { PrismHeaders } from '../enums';

@Injectable({
  providedIn: 'root'
})
export class MembersService {
  constructor(private http: HttpClient) {}

  private fetchingMembers: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private fetchingMemberCount: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private _jobsListPaginationData: BehaviorSubject<any> = new BehaviorSubject<any>({
    pageSize: 10,
    pageIndex: 0
  });

  private membersRequest?: Subscription;
  private memberCountRequest?: Subscription;

  fetchMembersFromDatabase(isActive = true) {
    this.membersRequest?.unsubscribe();
    const paginationData = this._jobsListPaginationData.value;
    const callFunction = isActive ? '/admin-get-members' : '/admin-get-members-filter';
    const headers = new HttpHeaders().append(
      PrismHeaders.QueryData,
      JSON.stringify({ ...paginationData })
    );

    this.membersRequest = this.http
      .get(environment.apiBaseUrl + callFunction, { headers })
      .pipe(
        take(1),
        map((jobsResponse: any) => {
          return jobsResponse.data.map((data: any) => {
            return {
              memberId: data.memberId,
              firstName: (data.firstName = data.firstName === undefined ? '-' : data.firstName),
              lastName: (data.lastName = data.lastName === undefined ? '-' : data.lastName),
              loginEmail: data.loginEmail,
              disabled: data.disabled
            };
          });
        })
      )
      .subscribe((data) => {
        this.fetchingMembers.next(data);
      });
  }

  getActiveMembers() {
    return this.http.get(environment.apiBaseUrl + '/admin-get-members').pipe(
      take(1),
      map((jobsResponse: any) => {
        return jobsResponse.data.map((data: any) => {
          return {
            memberId: data.memberId,
            firstName: (data.firstName = data.firstName === undefined ? '-' : data.firstName),
            lastName: (data.lastName = data.lastName === undefined ? '-' : data.lastName),
            loginEmail: data.loginEmail,
            disabled: data.disabled
          };
        });
      })
    );
  }

  getMemberCountData(isActive = true) {
    const callFunction = isActive ? '/admin-get-member-count' : '/admin-get-member-count-filter';
    this.memberCountRequest?.unsubscribe();
    this.memberCountRequest = this.http
      .get(environment.apiBaseUrl + callFunction)
      .pipe(
        take(1),
        map((countResponse: any) => {
          return countResponse.data;
        })
      )
      .subscribe((data) => {
        this.fetchingMemberCount.next(data);
      });
  }

  addMember(memberData: any) {
    return this.http.post(environment.apiBaseUrl + '/admin-add-member', memberData).pipe(take(1));
  }

  getMember(data: any) {
    let email = data.loginEmail;
    let headers = new HttpHeaders().append(PrismHeaders.QueryData, JSON.stringify({ email }));

    return this.http.get(environment.apiBaseUrl + '/admin-get-member', { headers });
  }

  changeMemberState(data: any) {
    let state = data.actionType.toLowerCase();
    return this.http.put(environment.apiBaseUrl + `/admin-${state}-member`, {
      email: data.loginEmail
    });
  }

  updateMemberData(body: any) {
    return this.http.put(environment.apiBaseUrl + '/admin-update-member', body);
  }

  getDownloadData(start: any, end: any) {
    let reqData: any = {
      startData: start,
      endData: end
    };
    const headers = new HttpHeaders().append(PrismHeaders.QueryData, JSON.stringify(reqData));
    return this.http.get(environment.apiBaseUrl + '/admin-get-download-data', { headers });
  }

  getStatisticsData(start: any, end: any) {
    let reqData: any = {
      startData: start,
      endData: end
    };
    const headers = new HttpHeaders().append(PrismHeaders.QueryData, JSON.stringify(reqData));
    return this.http.get(environment.apiBaseUrl + '/admin-get-statistics-data', { headers });
  }

  getMembersListUpdateListener$() {
    return this.fetchingMembers.asObservable();
  }

  getMembersCountListener$() {
    return this.fetchingMemberCount.asObservable();
  }

  updateJobsListPagination({ pageSize, pageIndex }: any) {
    this._jobsListPaginationData.next({ pageSize, pageIndex });
  }

  getTotalInvoiceData(start: any, end: any) {
    let reqData: any = {
      startData: start,
      endData: end
    };
    const headers = new HttpHeaders().append(PrismHeaders.QueryData, JSON.stringify(reqData));
    return this.http.get(environment.apiBaseUrl + '/admin-get-invoice-totals', { headers });
  }
}
